export const IMG_API = "";
export const IMG_ACTION = "action.png"; 
export const IMG_LOGO = "test-logo.png"; 
export const IMG_SUPERADMIN = "superadmin.jpg"; 
export const IMG_AFFILIATE = "affiliate.jpg"; 
export const IMG_CLIENT = "client.jpg"; 
export const IMG_CREW_PROFILE = "crew-icon.png"; 
